import get from 'lodash.get';
import { emptyArray } from '../../default-props/empty';

export const serviceGroups = (state) => get(state, 'serviceGroups', emptyArray);
export const fulfillmentPlanId = (state) => get(state, 'fulfillmentPlanId', 0);
export const isRequired = (state) => get(state, 'isRequired', false);
export const isLoading = (state) => get(state, 'isLoading');
